import {SUBSCRIPTION_ROOT_PATH} from '../../pages/Subscription/subscriptionPaths';
import {ISidebarConfig} from './types';

export const COMPANY_USERS_PATH = '/profile/users';

export const getSidebarConfig = (isCompanyOwner = false): ISidebarConfig[] => [
    {path: '/profile', label: 'Мой профиль'},
    {path: SUBSCRIPTION_ROOT_PATH, label: 'Подписка'},
    ...(isCompanyOwner ? [{path: COMPANY_USERS_PATH, label: 'Пользователи'}] : []),
    {path: 'exit', label: 'Выйти'},
];

export const sidebarConfig: ISidebarConfig[] = getSidebarConfig();
